import React, { useState, useRef, useEffect } from "react";
import useDynamicHeightField from "../common/hook/useDynamicHeightField";
import cn from "classnames";
import { updateAnalysisData } from "../../service/api.service";
import { EventEmitter } from "../../event"
import withSnackbar from "../common/hook/useNotification";

const INITIAL_HEIGHT = 46;
 
let state = { msg: '', activeDisk: '' }
function CommentBox(props) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [commentValue, setCommentValue] = useState(state.msg);

  const outerHeight = useRef(INITIAL_HEIGHT);
  const textRef = useRef(null);
  const containerRef = useRef(null);
  useDynamicHeightField(textRef, commentValue);

  useEffect(() => {
    // diskCode 
    if (props.msg && (state.diskCode !== props.diskCode || !state.diskCode)) {
      state.msg = props.msg
      state.diskCode = props.diskCode;
      setData()

    }
  });

  function setData() {
    setCommentValue(props.msg);
  }

  const onExpand = () => {
    if (!isExpanded) {
      outerHeight.current = containerRef.current.scrollHeight;
      setIsExpanded(true);
    }
  };

  const onChange = (e) => {
    state.msg = e.target.value;
    setCommentValue(e.target.value);
  };

  const onClose = () => {
    state.msg = "";
    setCommentValue("");
    setIsExpanded(false);
  };

  const onSubmit = (e) => {
     updateAnalysisData(commentValue, props.diskCode, props.type, resp => {
       // state.msg= "";
      setIsExpanded(false);
      props.snackbarShowMessage(`Feedback added Successfully`);
      EventEmitter.dispatch("feebackToggle", "false");
    })
    e.preventDefault();
  };

  return (
    <div className="commentbox">

      <form
        onSubmit={onSubmit}
        ref={containerRef}
        className={cn("comment-box", {
          expanded: isExpanded,
          collapsed: !isExpanded,
          modified: commentValue.length > 0
        })}
        style={{
          minHeight: isExpanded ? outerHeight.current : INITIAL_HEIGHT
        }}
      >
        <div className="header">
          <div className="user"> 
            <svg  className="svg-icon h-8 w-8 avatar mr-3" viewBox="0 0 60 60"   >
              <path fill="#000" d="M48.014,42.889l-9.553-4.776C37.56,37.662,37,36.756,37,35.748v-3.381c0.229-0.28,0.47-0.599,0.719-0.951
	c1.239-1.75,2.232-3.698,2.954-5.799C42.084,24.97,43,23.575,43,22v-4c0-0.963-0.36-1.896-1-2.625v-5.319
	c0.056-0.55,0.276-3.824-2.092-6.525C37.854,1.188,34.521,0,30,0s-7.854,1.188-9.908,3.53C17.724,6.231,17.944,9.506,18,10.056
	v5.319c-0.64,0.729-1,1.662-1,2.625v4c0,1.217,0.553,2.352,1.497,3.109c0.916,3.627,2.833,6.36,3.503,7.237v3.309
	c0,0.968-0.528,1.856-1.377,2.32l-8.921,4.866C8.801,44.424,7,47.458,7,50.762V54c0,4.746,15.045,6,23,6s23-1.254,23-6v-3.043
	C53,47.519,51.089,44.427,48.014,42.889z"/>

            </svg>
 
            <span>Surgeon</span>
          </div>
        </div>
        <label htmlFor="comment">What are your thoughts?</label>
        <textarea
          ref={textRef}
          onClick={onExpand}
          onFocus={onExpand}
          onChange={onChange}
          className="comment-field"
          placeholder="What are your thoughts?"
          value={commentValue}
          name="comment"
          id="comment"
        />
        <div className="actions">
          <button type="button" className="mr-2 " onClick={onClose}>
            Cancel
          </button>
          <button type="submit" disabled={commentValue.length < 1} className={commentValue.length < 1 ? "cursor-not-allowed bg-[#1b2a47]  rounded text-white px-4 py-2 " : "px-4 py-2 bg-[#002E98] rounded text-white"}>
            Save
          </button>
        </div>
      </form>
    </div>
  );
}
export default withSnackbar(CommentBox);